/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Error from 'next/error';
import { COMMON } from '../route-constants';
import clientOnly from '../util/client-only';

import './error.less';

const ErrorPage = ({ err, statusCode }) => {
  /**
   * Send client-side error information to New Relic
   */
  useEffect(() => {
    clientOnly(() => {
      if (window.newrelic && window.newrelic.noticeError) {
        window.newrelic.noticeError(err, {
          errorType: 'Error Boundary',
        });
      }
    });
  }, [err]);

  /**
   * Browswer refresh page onClick
   */
  const onClick = () => {
    window.location.reload();
  };

  /**
   * Use the standard Next.js error template for server-side errors
   */
  if (statusCode) {
    return <Error statusCode={statusCode} />;
  }

  /**
   * Use a custom error template for client-side errors
   */
  return (
    <div className='ErrorPage'>
      <p>
        Uh oh, something went wrong. Please
        <button
          type='button'
          className='button text reloadButton'
          href='#'
          // eslint-disable-next-line react/jsx-no-bind
          onClick={onClick}>
        reload the page.
        </button>
      </p>
    </div>
  );
};

ErrorPage.propTypes = {
  statusCode: PropTypes.oneOfType([PropTypes.number, null]).isRequired,
  err: PropTypes.any.isRequired,
};

const statusCodes = {
  [COMMON.PAGE_ERRORS.PAGE_NOT_FOUND]: 404,
  [COMMON.PAGE_ERRORS.NOT_AUTHENTICATED]: 401,
  [COMMON.PAGE_ERRORS.FORBIDDEN]: 403,
};

ErrorPage.getInitialProps = (ctx) => {
  const { res, err } = ctx;
  const errorType = (err && err.message) || '';
  let statusCode = res ? res.statusCode : null;

  // Set response status code if this is a known error type
  if (res && statusCodes[errorType]) {
    statusCode = statusCodes[errorType];
    res.statusCode = statusCode;
  }

  return { err, statusCode };
};

export default ErrorPage;
